export default __webpack_public_path__ + "static/media/ic-grass-only.8cfd6bdb.svg";